import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useTasks, TaskDetails } from '@dev-streetbeat/chat';

import { ChatAgentCheckIcon } from 'shared/assets/svg/ChatAgentCheckIcon';

import styles from './taskStatuses.module.scss';

type Props = {};

export const TaskStatuses: React.FC<Props> = () => {
  const { tasks } = useTasks();
  // Use tasks from useTasks hook if available, otherwise fall back to parsing message content
  const tasksToRender = tasks.length > 0 ? tasks : ([] as TaskDetails[]);

  if (!tasksToRender || tasksToRender.length === 0) {
    return null;
  }

  return (
    <div className={styles.taskStatusesContainer}>
      {tasksToRender.map((task, index) => (
        <TaskStatusItem key={task.id || index} task={task as TaskDetails} />
      ))}
    </div>
  );
};

const TaskStatusItem: React.FC<{ task: TaskDetails }> = ({ task }) => {
  const { t } = useTranslation();

  const getStatusText = () => {
    let statusText = task.message || task.title || task.description || t('assistant.status.processing');

    if (!task.is_completed) {
      // Add progress if available
      if (task.progress && task.progress > 0) {
        const progressPercent = Math.round(task.progress * 100);
        statusText += ` (${progressPercent}%)`;
      }

      // Add step information
      if (task.current_step && task.total_steps) {
        statusText += ` - ${t('assistant.tasks.step')} ${task.current_step}/${task.total_steps}`;
      }
    }

    return statusText;
  };

  return (
    <div className={styles.taskStatusItem}>
      <div className={styles.taskStatusContent}>
        <div
          className={classNames(styles.checkIconContainer, {
            [styles.checkIconContainerNotCompleted]: !task.is_completed,
          })}
        >
          <ChatAgentCheckIcon />
        </div>

        <span className={styles.taskStatusText}>{getStatusText()}</span>
      </div>
      {!task.is_completed && task.progress != null && (
        <div className={styles.progressBar}>
          <div className={styles.progressFill} style={{ width: `${Math.round(task.progress * 100)}%` }} />
        </div>
      )}
    </div>
  );
};

export default TaskStatuses;
